import React from 'react'
import download from '../assets/download.svg'
import x from '../assets/x.svg'
import fb from '../assets/fb.svg'
import ig from '../assets/ig.svg'

export default function Download() {
    return (
        <div id="download" className="flex flex-col min-h-screen scroll-mt-20 p-6 my-12 gap-5">
            <h1 className="text-4xl font-semibold mb-4">Odkazy ke stažení</h1>
            <p className=''>Aplikace Jídelák je aktuálně k dispozici ke stažení <strong>pouze na App Store</strong>.
            </p>
            <p className=''>
                Pro zpřístupnění aplikace na Google Play musíme sehnat 20 dobrovolných testerů pro naši aplikaci. <strong>Kontaktujte nás a pomozte nám</strong> dostat aplikaci mezi širší skupinu lidí na Google Play!
            </p>            
            <div className='flex mx-8'>
                <div className='max-w-60 min-h-10 hover:scale-110 active:scale-95'>
                    <a href="https://apps.apple.com/cz/app/j%C3%ADdel%C3%A1k/id6479896766?l=cs" target='_blank'><img src={download} alt="download"/></a>
                </div>
            </div>
            <p className=''>Kontaktní email: <a href='mailto:hiskymek@gmail.com' className='font-bold hover:text-slate-400'>hiskymek@gmail.com</a></p>
            <p className=''>Nebo nám můžete napsat na jedné z našich sociálních sítí:</p>
            <div className='flex justify-between max-w-96 mx-8'>
                <a href="https://www.facebook.com/jidelakapp" target='_blank' className='hover:scale-110 active:scale-95'><img src={fb} alt="fb-logo" width={64} /></a>
                <a href="https://x.com/jidelak_app" target='_blank' className='hover:scale-110 active:scale-95'><img src={x} alt="x-logo" width={64}/></a>
                <a href="https://www.instagram.com/jidelak_app/" target='_blank' className='hover:scale-110 active:scale-95'><img src={ig} alt="ig-logo" width={64}/></a>
            </div>
        </div>
    )
}
